<template>
  <v-dialog v-model="openNotificationDialog" max-width="500px" persistent>
    <div class="notifications-container">
      <v-row justify="space-between">
        <h1 class="notifications-title">
          <span v-if="notificationEvents.length != 1">{{
            $t('notification.titlePlural')
          }}</span>
          <span v-else>{{ $t('notification.titleSingular') }}</span>
        </h1>
        <v-btn color="secondary" icon @click="discardNotifications">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-row>
      <v-row>
        <v-col v-if="notificationEvents.length">
          <div
            v-for="event in notificationEvents"
            :key="event.id"
            class="notification-event"
          >
            <div class="event-days-until">
              <span class="bullet">&bull;</span>
              <span> {{ getDaysUntilDate(event.startDate) }} </span>
            </div>
            <div class="event-name">{{ event.name }}</div>
            <div class="event-date">{{ getDateRange(event) }}</div>
            <div
              class="event-leaders"
              v-if="event.leaders"
              v-html="event.leadersHtml"
            />
            <div class="event-description" v-if="event.description">
              {{ event.description }}
            </div>
          </div>
        </v-col>
        <v-col v-else>
          {{ $t('notification.noEvents') }}
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn
          color="primary"
          class="mr-4 mt-4"
          @click="rememberAgain"
          v-if="notificationEvents.length"
        >
          {{ $t('notification.remindAgain') }}
        </v-btn>
        <v-btn class="mr-4 mt-4" @click="discardNotifications">
          {{ $t('common.close') }}
        </v-btn>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { getDiffDaysBetweenDates, getCalendarDate } from '@/utils/common'
import _isEmpty from 'lodash/isEmpty'

export default {
  data: () => ({
    today: getCalendarDate(new Date().getTime())
  }),
  watch: {
    notificationEvents(newVal) {
      if (newVal.length) {
        this.showNotifications()
      }
    },
    leadersMap(newVal) {
      if (!_isEmpty(newVal)) {
        this.$store.dispatch('eventStore/fetchNotificationEvents', newVal)
      }
    }
  },
  computed: {
    ...mapState({
      notificationEvents: state => state.eventStore.notificationEvents,
      openNotificationDialog: state => state.eventStore.openNotificationDialog,
      leadersMap: state => state.leaderStore.leadersMap
    }),
    todayText() {
      return this.$t('notification.today')
    },
    inText() {
      return this.$t('notification.in')
    },
    dayText() {
      return this.$t('notification.day')
    },
    daysText() {
      return this.$t('notification.days')
    }
  },
  methods: {
    showNotifications() {
      //Validates whether to show or not notifications
      const discardedIds = JSON.parse(localStorage.getItem('bd-kol-discarded'))
      const ids = this.notificationEvents.map(event => event.id)
      let wasDiscarded = false
      if (discardedIds) {
        wasDiscarded = ids.every(id => discardedIds.includes(id))
      }
      if (wasDiscarded) {
        this.$store.dispatch('eventStore/showNotification', false)
      } else {
        this.$store.dispatch('eventStore/openNotificationDialog', true)
      }
    },
    closeDialog() {
      this.$store.dispatch('eventStore/openNotificationDialog', false)
    },
    rememberAgain() {
      this.closeDialog()
      localStorage.removeItem('bd-kol-discarded')
      this.$store.dispatch('eventStore/showNotification', true)
    },
    discardNotifications() {
      const discarded = this.notificationEvents.map(event => event.id)
      localStorage.setItem('bd-kol-discarded', JSON.stringify(discarded))
      this.$store.dispatch('eventStore/showNotification', false)
      this.closeDialog()
    },
    getDaysUntilDate(strDate) {
      if (strDate === this.today) {
        return this.todayText
      }
      const diff = getDiffDaysBetweenDates(
        new Date(strDate),
        new Date(this.today)
      )
      return this.inText + diff + (diff === 1 ? this.dayText : this.daysText)
    },
    getDateRange(event) {
      if (event.startDate === event.endDate) {
        return event.start + ' - ' + event.endTime
      }
      return event.start + ' - ' + event.end
    }
  }
}
</script>
<style lang="scss">
.notifications-container {
  background-color: #fff;
  padding: 20px 32px;
  word-break: break-word;

  .notifications-title {
    text-align: left;
    color: #2e478d;
    font-size: 22px;
    padding-left: 10px;
  }

  .notification-event {
    padding-bottom: 20px;

    .event-days-until {
      color: #31649e;
      font-weight: bold;
      .bullet {
        font-size: 24px;
        line-height: 27px;
        float: left;
        margin-right: 5px;
      }
    }
    .event-name {
      padding-left: 15px;
      font-weight: bold;
      font-size: 20px;
    }
    .event-date {
      padding-left: 15px;
      color: #1e346d;
      font-weight: bold;
    }
    .event-description,
    .event-leaders {
      padding-left: 15px;
      color: #5d5d5d;
    }
    .event-leaders {
      font-weight: bold;
    }
  }
}
</style>
